// components/NavBar/index.ts
import NavBar from "./NavBar";

export default NavBar;